//
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'Estado',
        value: 'status',
        align: 'center',
        component: {
            custom: 'has_state',
            type: 'chip',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
        width: '10%',
    },
    {
        text: 'solicitado',
        value: 'quantity',
        align: 'right',
        width: '10%',
    },
    {
        text: 'enviado',
        value: 'quantity_dispatch',
        align: 'right',
        width: '10%',
    },
    {
        text: 'restante',
        value: 'remnant',
        align: 'right',
        //classes: 'primary',
        width: '10%',
    },
    {
        text: 'recepcionado',
        value: 'received',
        align: 'right',
        input: {
            custom: 'receive',
            min: 1,
            nativeType: 'number',
            reverse: true,
            type: 'text-field',
        },
        width: '10%',
    },
]
